export default __webpack_public_path__ + "static/media/icon-add-link.9295eb32.svg";